import React from 'react';
import { InstagramIcon, MailIcon, MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
const HOURS = [['Mon – Fri', '8:00 AM – 7:00 PM'], ['Saturday', '9:00 AM – 5:00 PM'], ['Sunday', 'Closed']];
export function Footer() {
  return <footer className="w-full bg-slate text-white" data-id="element-65" data-mp="32lrm3dfusxjz">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16" data-id="element-66" data-mp="36oo5h6d7wxoz">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4" data-id="element-67" data-mp="3uf0obca04euc">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-68" data-mp="3ud7gvurkdqla">
            <a href="#home" className="flex items-center gap-2" data-id="element-69" data-mp="38zawx2kd95j">
              <img src="https://cdn.magicpatterns.com/uploads/iCSgMNo9mofRGomq3yMKNi/Logo_Ally_C.png" alt="Logo circular de Ally Cleaning Services" className="h-9 w-9 rounded-full object-contain" data-id="element-70" data-mp="3lec8qd4ym6fc" />
              <span className="leading-tight" data-id="element-71" data-mp="29xm0kogz74j3">
                <span className="block font-display font-extrabold tracking-tight text-lg" data-id="element-72" data-mp="2ey0a6ay86mj8">
                  Ally
                </span>
                <span className="block text-[10px] uppercase tracking-[0.22em] text-white/50 -mt-0.5" data-id="element-73" data-mp="3labp9pa6nun7">
                  Cleaning Boutique
                </span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-74" data-mp="3v8hqs5s2uyrj">
              Boutique, eco-friendly cleaning for discerning homes across
              Manhattan, Queens &amp; Long Island.
            </p>
            <div className="mt-5 flex gap-3" data-id="element-75" data-mp="81fqhygiyw59">
              <a href="https://www.instagram.com/ally.cleaninservices" target="_blank" rel="noreferrer" aria-label="Visit Ally Cleaning Services on Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-magenta transition-colors" data-id="element-76" data-mp="34741locg5y7">
                <InstagramIcon className="h-5 w-5" data-id="element-77" data-mp="qrfba95c1p2v" />
              </a>
            </div>
          </div>

          {/* Hours */}
          <div data-id="element-78" data-mp="tvcyrpppu1e3">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-79" data-mp="tvw66chqp7dv">
              <ClockIcon className="mr-2 inline h-4 w-4 text-sky-brand" data-id="element-80" data-mp="ytehuan560pk" />
              Business Hours
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-white/60" data-id="element-81" data-mp="13sipuxybxseb">
              {HOURS.map(([day, time]) => <li key={day} className="flex justify-between gap-4" data-id="element-82" data-mp="18lk6pbi3k20j">
                  <span data-id="element-83" data-mp="1cmdve73d5kuh">{day}</span>
                  <span className="text-white/80" data-id="element-84" data-mp="1clckq3q9f0da">{time}</span>
                </li>)}
            </ul>
            <p className="mt-3 text-xs font-medium text-sky-brand" data-id="element-85" data-mp="1hms2nmx54qrg">
              Yes — we&apos;re open Saturdays!
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-86" data-mp="1rid1xdatrcxi">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-87" data-mp="1rgsiojtyngey">
              Get in Touch
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-88" data-mp="3t9q6g18vrit1">
              <li className="flex items-start gap-2" data-id="element-89" data-mp="3tc2vszgywvg4">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-90" data-mp="2ag5csk60p0dh" />
                Manhattan · Queens · Long Island
              </li>
              <li className="flex items-start gap-2" data-id="element-91" data-mp="25mkd8norzyc6">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-92" data-mp="21nlclfa2unqj" />
                <a href="mailto:allycleaningservices1@gmail.com" className="break-all hover:text-white transition-colors" data-id="element-93" data-mp="1woi6rsm9wdhi">
                  Email: allycleaningservices1@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-94" data-mp="2kdb49tijmte8">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-95" data-mp="2kbqaw77ytghy" />
                <a href="sms:+19296509940" className="hover:text-white transition-colors" data-id="element-96" data-mp="2fd5ao7spqwti">
                  Text/Call: (929) 650-9940
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-97" data-mp="13xgq1n2xm9vv">
                <InstagramIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-98" data-mp="2rv7nvttzprz7" />
                <a href="https://www.instagram.com/ally.cleaninservices" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-id="element-99" data-mp="2wm7l7070uc28">
                  Instagram: @ally.cleaninservices
                </a>
              </li>
            </ul>
            <a href="#quote" className="mt-5 inline-flex rounded-full bg-magenta px-5 py-2.5 text-sm font-semibold text-white hover:bg-magenta-dark transition-colors" data-id="element-100" data-mp="3bl1jyk3qmt98">
              Book Now
            </a>
          </div>

          {/* Map */}
          <div data-id="element-101" data-mp="36jkq38jo8725">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-102" data-mp="36j2k3k77ieh1">
              Find Us
            </h3>
            <div className="mt-4 overflow-hidden rounded-2xl ring-1 ring-white/10" data-id="element-103" data-mp="1v5gujxxfqauz">
              <iframe title="Service area map — New York City" src="https://www.openstreetmap.org/export/embed.html?bbox=-74.05%2C40.65%2C-73.75%2C40.85&layer=mapnik" className="h-40 w-full grayscale" loading="lazy" data-id="element-104" data-mp="1v3dyaw5ovlht" />
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 text-center text-xs text-white/40" data-id="element-105" data-mp="1rnb0mq32e66m">
          © {new Date().getFullYear()} Ally Cleaning Boutique NYC. All rights
          reserved.
        </div>
      </div>
    </footer>;
}